<script>
export default {
  name: "searchResultsViewChange",
  data() {
    return {
      filterOptions: [
        {
          value: "time",
          label: "Newest to oldest listed"
        },
        {
          value: "timeasc",
          label: "Oldest to newest listed"
        },
        {
          value: "price",
          label: "Lowest to highest price"
        },
        {
          value: "pricedsc",
          label: "Highest to lowest price"
        }
      ],
      selectedFilterOption: "Newest to oldest listed"
    };
  },
  methods: {
    setSort() {
      sessionStorage.setItem("searchSort", this.selectedFilterOption);
      let options = "";
      if (sessionStorage.searchFiltersForm) {
        options = JSON.parse(sessionStorage.searchFiltersForm);
      }
      options.sort = this.selectedFilterOption;
      sessionStorage.setItem("searchFiltersForm", JSON.stringify(options));
      this.$emit("loadSearch");
    }
  },
  mounted() {
    this.selectedFilterOption = sessionStorage.searchSort
      ? sessionStorage.searchSort
      : "Newest to oldest listed";
  }
};
</script>

<template>
  <el-row style="background-color: #ffffff">
    <el-col
      :span="24"
      style="display: flex; justify-content: flex-end; align-items: center; padding: 0 16px; gap: 10px"
    >
      <span class="span-text">Sort by:</span>
      <el-select
        v-model="selectedFilterOption"
        placeholder="Select"
        @change="setSort"
      >
        <el-option
          v-for="item in filterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="24" style="padding: 0 16px 0 16px;">
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- change offset back to 8 when displaying map view -->
        <!--<el-col :offset="16" :span="8" style="display: flex; align-items: center; gap: 5px; justify-content: flex-end">
          <span class="span-text">List View</span>
          <img
            loading="lazy"
            src="../../assets/view-list.svg"/>
        </el-col>-->
        <!-- <el-col :span="8" style="display: flex; align-items: center; gap: 5px">
          <span class="span-text">Map View</span>
          <img
            loading="lazy"
            src="../../assets/map.svg"/>
        </el-col> -->
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.span-text {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 18px DINosaur-a, sans-serif;
}
.el-select /deep/ .el-input__inner {
  color: #003333;
  font: 500 16px DINosaur-a, sans-serif;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/search/searchResultsViewChange.vue